import styles from "./styles.module.scss";
import figma_icon from "../../../graphics/figma_icon.svg";
import market_1 from "../../../images/market_1.png";
import market_2 from "../../../images/market_2.png";
import market_3 from "../../../images/market_3.png";
import market_4 from "../../../images/market_4.png";
import market_5 from "../../../images/market_5.png";
import market_6 from "../../../images/market_6.png";
import market_7 from "../../../images/market_7.png";
import market_8 from "../../../images/market_8.png";
import market_9 from "../../../images/market_9.png";
import Section from "../../../components/Section";

const Market = () => {
  return (
    <Section>
      <h2 className={styles.title}>
        Приложение для сети магазинов здорового питания
      </h2>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.item}>
            <h4 className={styles.subtitle}>Бизнес-задача</h4>
            <p className={styles.text}>
              Спроектировать приложение для сети, которая продает органические
              овощи и фрукты, предлагая хорошее качество по конкурентоспособной
              цене.
            </p>
          </div>

          <div className={styles.item}>
            <h4 className={styles.subtitle}>Реализация</h4>
            <p className={styles.text}>
              Для передачи ценностей бренда использовала естественные цвета и
              чистый дизайн, фокусировалась на визуальной простоте и удобстве
              навигации, чтобы повысить доверие к магазину.
            </p>
          </div>
        </div>

        <div className={styles.images}>
          <div className={styles.item}>
            <img src={market_1} alt="" />
          </div>
          <div className={styles.item}>
            <img src={market_2} alt="" />
          </div>
          <div className={styles.item}>
            <img src={market_3} alt="" />
          </div>
          <div className={styles.item}>
            <img src={market_4} alt="" />
          </div>
          <div className={styles.item}>
            <img src={market_5} alt="" />
          </div>
          <div className={styles.item}>
            <img src={market_6} alt="" />
          </div>
          <div className={styles.item}>
            <img src={market_7} alt="" />
          </div>
          <div className={styles.item}>
            <img src={market_8} alt="" />
          </div>
          <div className={styles.item}>
            <img src={market_9} alt="" />
          </div>
        </div>
      </div>
    </Section>
  );
};

export default Market;
